import { personInfoAddressFrag } from '../../../../utils/type/person.common-type';

export const socialAcquireProcessFrag = `
    id
    folderId
    folder {
        id
    }
    primaryContactDate
    primaryContactDateLabel
    applicantInactiveFrom
    requestDate
    requestApproveDate
    requestCancellingDate
    requestCancellingReason
    requestWithdrawnDate
    wishToBeInWaitingList    
    contractId
    contract {
        id
        contractNumber
        validFrom
        validTo
    }
    waitingList {
        id
        folderId
        folder {
            id
            serviceId
            personId
            person {
                ${personInfoAddressFrag}
            }
        }
        entryDate
        dateTo
        removalReason
        readyToUseService
        note
        ratingPoints
        form
        files
    }
`;

export const socialAcquireProcessUpdateFrag = `
    id
`;

export const socialAcquireProcessCreateFrag = `
    id
`;

export const folderStatusHistoryFrag = `
    id
    status
    dateFrom
    dateTo
`;

export const getIndividualPlansFrag = `
    id
    date
    targets(input: __TARGET_FILTER__) {
        id
        name
        status
        dateFrom
        dateTo
    }
`;
